import React from 'react';
import clsx from 'clsx';
import { getConfigProperty } from '../../../common/utils/getConfigProperty';

function UserProfileAvatarView({ avatarId, className, ...rest }) {
    const staticUrl = getConfigProperty('staticContentUrl', 'static.url');
    return (
        <div className={clsx('flex items-center justify-center user-profile-avatar-box', className)}>
            <img
                className="user-profile-avatar"
                src={`${staticUrl}/asset/avatar/${avatarId}.png`}
                alt="avatar"
                {...rest}
            />
        </div>
    );
}

export default UserProfileAvatarView;
